import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { NotifierPopup } from 'bricks';
import Image from 'bricks/Image';
import { IncludeContent } from 'bricks/IncludeContent';
import {
  NOTIFY_CONTENT_TYPE_IMG,
  NOTIFY_CONTENT_TYPE_MARKUP,
  NOTIFY_CONTENT_TYPE_TXT,
  NOTIFY_CONTENT_TYPE_WIDGET,
} from 'store/common/notify/constants';
import {
  getNotificationContent,
  getNotificationHasContent,
  getUseNotificationState,
} from 'store/common/notify/selectors';

import WidgetSwitcher from './components/WidgetSwitcher';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/* switcher by content type */
const NotifyContentSwitcher = ({ content, isMobile, type, widgetsProps }) => {
  switch (type) {
    case NOTIFY_CONTENT_TYPE_IMG:
      return <Image {...{ ...content, useLazyLoad: false }} />;
    case NOTIFY_CONTENT_TYPE_WIDGET:
      return <WidgetSwitcher {...{ ...content, isMobile, widgetsProps }} />;
    case NOTIFY_CONTENT_TYPE_TXT:
      return <span className={cx('notify', 'text', { isMobile })}>{content.value}</span>;
    case NOTIFY_CONTENT_TYPE_MARKUP:
      return <IncludeContent htmlContent={content.value} />;
    default:
      return <span className={cx('notify', 'text', { isMobile })}>{content.value}</span>;
  }
};

NotifyContentSwitcher.propTypes = {
  content: PropTypes.shape({
    value: PropTypes.any,
    /**
     * There is a lot of possible props, cause of multiple widgets,
     * so propTypes should be watched in widget layout.
     */
  }),
  isMobile: PropTypes.bool,
  type: PropTypes.string,
  /* this prop is for tunneling actions and other widget-specific props */
  widgetsProps: PropTypes.object,
};

class SimpleNotifier extends React.PureComponent {
  constructor(props) {
    super(props);
    const { isOpen } = props;
    this.state = {
      isNotifyOpen: isOpen,
    };
  }

  openNotify = () => this.setState({ isNotifyOpen: true });

  closeNotify = () => this.setState({ isNotifyOpen: false });

  handleCloseNotify = () => {
    const { onClose } = this.props;
    this.closeNotify();
    if (onClose) onClose();
  };

  render() {
    const {
      className,
      hasNotificationContent,
      isMobile,
      notificationContent,
      useNotification,
      widgetsProps,
    } = this.props;
    // ===
    const { isNotifyOpen } = this.state;

    return (
      useNotification && (
        <NotifierPopup onClose={this.handleCloseNotify} opened={isNotifyOpen} {...{ isMobile }}>
          <div className={cx('wrapper', className)}>
            {hasNotificationContent &&
              notificationContent.map(({ content, type }, index) => (
                <NotifyContentSwitcher
                  key={`${type}_${+index}`}
                  {...{ content, isMobile, type, widgetsProps }}
                />
              ))}
          </div>
        </NotifierPopup>
      )
    );
  }
}

SimpleNotifier.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hasNotificationContent: PropTypes.bool,
  isMobile: PropTypes.bool,
  /* this prop is used for default state */
  isOpen: PropTypes.bool,
  notificationContent: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func,
  useNotification: PropTypes.bool,
  /* this prop is for tunneling actions and other widget-specific props */
  widgetsProps: PropTypes.object,
};

const mapStateToProps = (state) => ({
  hasNotificationContent: getNotificationHasContent(state),
  notificationContent: getNotificationContent(state),
  useNotification: getUseNotificationState(state),
});

// const mapDispatchToProps = {
//   getTypes: getDeviceTypes,
//   selectOption: selectDeviceOption,
// };

export default connect(mapStateToProps)(SimpleNotifier);
